// extracted by mini-css-extract-plugin
module.exports =  {"typography-green":"fbDDs_Y","typographyGreen":"fbDDs_Y"};